import { cn } from "@bentolabs/kit/utils";
import { shortAddress } from "@bentolabs/kit/web3";
import { Address } from "viem";

type Props = {
  className?: string;
  account: Address;
  points: string;
  position: number;
  percent: number;
};

export const Row = (props: Props) => {
  const { className, account, percent, points, position } = props;
  return (
    <div
      className={cn(
        "bg-baltic-sea/30 grid grid-cols-[0.5fr_1fr_1fr_1fr] rounded-[10px] px-6 py-3.5",
        className
      )}
    >
      <div>{position}</div>
      <div className="text-nobel font-normal underline">
        {shortAddress(account, 6, 5)}
      </div>
      <div className="text-spearmint">{points}</div>
      <div className="justify-self-end">{percent.toFixed(3)}%</div>
    </div>
  );
};
